import { useMemo } from "react";
import { useIntl } from "react-intl";

export const useArrayDropdown = <T>(array: Array<T>, translationKeyPrefix: string, allowEmptyValue: boolean) => {
  const { formatMessage } = useIntl();

  return useMemo(() => {
    const options = array.map((x: any) => ({
      value: x as string,
      label: formatMessage({ id: `${translationKeyPrefix}.${x}` }),
    }));

    if (allowEmptyValue) {
      options.unshift({ value: "", label: "" });
    }

    return options;
  }, [array, translationKeyPrefix, allowEmptyValue, formatMessage]);
};
